import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function viewTicketDataReducer(state = initialState.viewTicketData, action) {
  switch (action.type) {
    case types.LOAD_VIEW_TICKET_DATA_SUCCESS:
      return action.viewTicketData;
    default:
      return state;
  }
}
